import React, { useEffect, useRef } from "react";
import { CornerDownLeft } from "lucide-react";

/** One selectable palette row: icon or logo, label, and a hint on the right. */
const CommandPaletteRow = ({ item, isSelected, onRun, onHover }) => {
  const rowRef = useRef(null);
  const Icon = item.icon;

  useEffect(() => {
    if (isSelected) rowRef.current?.scrollIntoView({ block: "nearest" });
  }, [isSelected]);

  return (
    <button
      ref={rowRef}
      type="button"
      onClick={onRun}
      onMouseMove={onHover}
      className={`flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left transition-colors ${
        isSelected ? "bg-[#f1effc]" : "hover:bg-slate-50"
      }`}
    >
      {item.logo ? (
        <img
          src={item.logo}
          alt=""
          className="h-8 w-8 shrink-0 rounded-lg bg-white object-cover ring-1 ring-black/5"
        />
      ) : (
        <span
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors ${
            isSelected
              ? "bg-[#7f7ad5] text-white"
              : "bg-slate-100 text-slate-500"
          }`}
        >
          <Icon className="h-4 w-4" />
        </span>
      )}
      <span className="min-w-0 flex-1">
        <span
          className={`block truncate text-sm ${
            isSelected ? "font-medium text-[#2b2560]" : "text-slate-700"
          }`}
        >
          {item.label}
        </span>
        {item.description && (
          <span className="block truncate text-xs text-slate-400">
            {item.description}
          </span>
        )}
      </span>
      <span className="shrink-0 text-xs text-slate-400">{item.hint}</span>
      <CornerDownLeft
        className={`h-3.5 w-3.5 shrink-0 text-[#7f7ad5] ${
          isSelected ? "opacity-100" : "opacity-0"
        }`}
      />
    </button>
  );
};

export default CommandPaletteRow;
